/* Ebbrest: сцена «что под простынёй». Листает отрендеренные кадры на canvas по доле прокрутки.
   Без библиотек: один слушатель scroll (passive) плюс requestAnimationFrame, расчёт идёт только пока
   секция на экране, кадры начинают грузиться, когда секция подходит к экрану. Источник кадров и логика
   те же, что в products/bed-cooling-system/scene-3d (src/components/FrameScene.tsx): при правках держать
   их согласованными. Описание набора кладёт на страницу assets/eb-unfold-manifest.js. */
(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var pad = function (i) { return String(i + 1).padStart(4, '0'); };
  var smooth = function (a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  var hex = function (h) { return [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16); }); };
  var mix = function (a, b, t) { return a.map(function (x, i) { return Math.round(x + (b[i] - x) * t); }); };
  var rgb = function (c, a) { return a === undefined ? 'rgb(' + c.join(',') + ')' : 'rgba(' + c.join(',') + ',' + a + ')'; };

  function init(root, manifest) {
    if (root.__ebUnfold) return;                       // секцию могут найти два тега script или редактор темы
    var stage = root.querySelector('.eb-unfold__stage');
    var canvas = root.querySelector('canvas');
    var ctx = canvas && canvas.getContext('2d');
    if (!stage || !ctx || !manifest || !manifest.count) { root.classList.add('eb-unfold--static'); return; }
    var blocks = [].slice.call(root.querySelectorAll('.eb-unfold__block'));
    var labels = { cool: root.querySelector('.eb-unfold__label--cool'), warm: root.querySelector('.eb-unfold__label--warm') };
    var narrow = matchMedia('(max-aspect-ratio: 11/10)');
    // Адрес файлов берётся по первому кадру из «Файлов» магазина. Параметр версии ?v= оставляем у всех
    // кадров: после перезаливки набора он меняется, и CDN с браузером не отдают старые картинки.
    var first = { d: root.getAttribute('data-frame-d') || '', m: root.getAttribute('data-frame-m') || '' };
    var urlOf = function (kind, i) {
      var f = first[kind[0]], q = f.indexOf('?') >= 0 ? f.slice(f.indexOf('?')) : '';
      return f.split('?')[0].replace('eb-unfold-' + kind[0] + '-0001.webp', '') + 'eb-unfold-' + kind + '-' + pad(i) + '.webp' + q;
    };
    var style = getComputedStyle(root);
    var token = function (name, fallback) { var v = style.getPropertyValue(name).trim(); return /^#[0-9a-f]{6}$/i.test(v) ? v : fallback; };
    var bgSpec = manifest.bg || ['#F7F3EC', '#0E1526'];
    var paper = token('--eb-paper', bgSpec[0]), night = token('--eb-night', bgSpec[1]);
    var pairs = [['--ebu-fg', '--eb-ink', '#141B2D', '--eb-on-night', '#F3EFE7'], ['--ebu-fg-soft', '--eb-ink-soft', '#4F5870', '--eb-on-night-soft', '#A9B3CC'],
      ['--ebu-rule', '--eb-line', '#DDD4C5', '--eb-night-line', '#2E3A5A']].map(function (p) { return [p[0], hex(token(p[1], p[2])), hex(token(p[3], p[4]))]; });
    var T = manifest.T || {}, nightT = manifest.night || [2, 3], fillT = T.fill || [0.52, 0.66], throughT = T.through || [0.86, 0.95];

    var set = null, kind = '', loading = '', portraitOk = !!manifest.portrait, frames = [], loop = [], generation = 0, alive = true;
    var target = 0, current = 0, drawn = -1, visible = false, started = false, raf = 0, lastMove = 0, loopStart = 0;
    // наведение на половины кровати: где нарисован кадр, видны ли подписи, где курсор и какая половина раскрыта
    var rect = null, labelsOn = 0, pointer = null, openSide = '', anchor = {}, down = null;

    var applyTheme = function (p) {
      var t = smooth(nightT[0], nightT[1], p), bg = mix(hex(paper), hex(night), t);
      // текст переключается резко около середины перехода: при плавной смене он на мгновение сливался бы с серым фоном
      var tf = smooth(0.46, 0.56, t);
      root.style.setProperty('--ebu-bg', rgb(bg));
      root.style.setProperty('--ebu-bg-0', rgb(bg, 0));
      pairs.forEach(function (x) { root.style.setProperty(x[0], rgb(mix(x[1], x[2], tf))); });
      return bg;
    };
    var nearest = function (i) {
      if (frames[i]) return i;
      for (var d = 1; d < frames.length; d++) {
        if (i - d >= 0 && frames[i - d]) return i - d;
        if (i + d < frames.length && frames[i + d]) return i + d;
      }
      return -1;
    };
    var place = function (x, y, w, h, dpr, p) {
      var tracks = set.tracks, n = set.count;
      var pos = p * (n - 1), lo = Math.max(0, Math.min(n - 2, Math.floor(pos))), k = pos - lo;
      var o = Math.max(smooth(fillT[0] + 0.05, fillT[0] + 0.09, p) * (1 - smooth(fillT[1], fillT[1] + 0.04, p)), smooth(throughT[1] - 0.03, throughT[1] + 0.02, p));
      rect = { x: x, y: y, w: w, h: h, dpr: dpr, lo: lo, k: k }; labelsOn = o;
      ['cool', 'warm'].forEach(function (name) {
        var el = labels[name], tr = tracks && tracks[name];
        if (!el) return;
        var on = !!tr && tr.length >= n && n >= 2 && o > 0.5;
        // подпись-ссылка доступна мыши и клавиатуре только пока видна
        el.style.pointerEvents = on ? 'auto' : 'none';
        if (el.tagName === 'A') el.tabIndex = on ? 0 : -1;
        if (!on && el === document.activeElement) el.blur();           // фокус не остаётся на невидимой ссылке
        if (!tr || tr.length < n || n < 2 || o < 0.01) { el.style.opacity = 0; return; }
        var u = tr[lo][0] + (tr[lo + 1][0] - tr[lo][0]) * k, v = tr[lo][1] + (tr[lo + 1][1] - tr[lo][1]) * k;
        el.style.opacity = o.toFixed(3);
        anchor[name] = [(x + u * w) / dpr, (y + v * h) / dpr];
        put(name);
      });
      hover();
    };
    // Подпись растёт вверх от точки привязки. Раскрытую карточку на низком окне не даём срезать верхом сцены.
    var OPEN_H = 172;
    var put = function (name) {
      var el = labels[name], a = anchor[name];
      if (!el || !a) return;
      var ty = name === openSide ? Math.max(a[1], Math.min(OPEN_H, stage.clientHeight)) : a[1];
      el.style.transform = 'translate3d(' + a[0].toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0) translate(-50%,-100%)';
    };
    // Какая половина под курсором: контуры половин приходят из рендера по кадрам (areas), точка проверяется
    // в координатах кадра. Работает только пока подписи видны.
    var inQuad = function (q, px, py) {
      var inside = false;
      for (var i = 0, j = 3; i < 4; j = i++) {
        var xi = q[i * 2], yi = q[i * 2 + 1], xj = q[j * 2], yj = q[j * 2 + 1];
        if ((yi > py) !== (yj > py) && px < (xj - xi) * (py - yi) / (yj - yi) + xi) inside = !inside;
      }
      return inside;
    };
    var sideAt = function (cx, cy) {
      var areas = set && set.areas;
      if (!rect || !areas || labelsOn < 0.5) return '';
      var b = canvas.getBoundingClientRect();
      var u = ((cx - b.left) * rect.dpr - rect.x) / rect.w, v = ((cy - b.top) * rect.dpr - rect.y) / rect.h, found = '';
      ['cool', 'warm'].forEach(function (name) {
        var a = areas[name]; if (!a || !a[rect.lo + 1]) return;
        var q = a[rect.lo].map(function (c, i) { return c + (a[rect.lo + 1][i] - c) * rect.k; });
        if (inQuad(q, u, v)) found = name;
      });
      return found;
    };
    var setOpen = function (side) {
      if (side === openSide) return;
      openSide = side;
      ['cool', 'warm'].forEach(function (name) { if (labels[name]) labels[name].classList.toggle('is-open', name === side && labels[name].tagName === 'A'); });
      stage.style.cursor = side && labels[side] && labels[side].tagName === 'A' ? 'pointer' : '';
      put('cool'); put('warm');
    };
    // Состояние пересчитывается по координатам курсора на каждой перерисовке: страница могла уехать под
    // неподвижной мышью. Подпись под фокусом клавиатуры остаётся раскрытой.
    var hover = function () {
      var focused = '';
      ['cool', 'warm'].forEach(function (name) { if (labels[name] && labels[name] === document.activeElement && labelsOn > 0.5) focused = name; });
      if (labelsOn <= 0.5) { setOpen(''); return; }
      if (!pointer) { setOpen(focused); return; }
      var over = '';
      ['cool', 'warm'].forEach(function (name) {
        var l = labels[name]; if (!l) return;
        var b = l.getBoundingClientRect();
        if (pointer.x >= b.left && pointer.x <= b.right && pointer.y >= b.top && pointer.y <= b.bottom) over = name;
      });
      setOpen(over || sideAt(pointer.x, pointer.y) || focused);
    };
    // кадр всегда виден целиком, поля заливаются фоном страницы, шов прячет градиент
    var paint = function (a, b, m, p) {
      var cw = canvas.width, ch = canvas.height, dpr = cw / Math.max(1, canvas.clientWidth), ar = set.width / set.height;
      var bg = applyTheme(p), c1 = rgb(bg), c0 = rgb(bg, 0);
      var fade = function (x0, y0, x1, y1, rx, ry, rw, rh) {
        var g = ctx.createLinearGradient(x0, y0, x1, y1); g.addColorStop(0, c1); g.addColorStop(1, c0);
        ctx.fillStyle = g; ctx.fillRect(rx, ry, rw, rh);
      };
      var img = function (x, y, w, h) {
        ctx.drawImage(a, x, y, w, h);
        if (b && m > 0.02) { ctx.globalAlpha = m; ctx.drawImage(b, x, y, w, h); ctx.globalAlpha = 1; }
        place(x, y, w, h, dpr, p);
      };
      ctx.fillStyle = c1; ctx.fillRect(0, 0, cw, ch);
      if (cw / ch >= ar) {
        var dw = ch * ar, dx = Math.round((cw - dw) / 2), e = Math.min(dw * 0.06, 120);
        img(dx, 0, dw, ch);
        if (dx > 0) { fade(dx, 0, dx + e, 0, dx, 0, e, ch); fade(dx + dw, 0, dx + dw - e, 0, dx + dw - e, 0, e, ch); }
      } else {
        var dh = cw / ar, dy = Math.round((ch - dh) * (kind === 'm' ? 0.3 : 0.5)), e2 = Math.min(dh * 0.05, 70);
        img(0, dy, cw, dh);
        fade(0, dy, 0, dy + e2, 0, dy, cw, e2); fade(0, dy + dh, 0, dy + dh - e2, 0, dy + dh - e2, cw, e2);
      }
    };
    // Тексты: окно блока в процентах прокрутки. Скрытые блоки остаются в дереве доступности (их читает
    // скринридер), просто прозрачны и не ловят нажатия.
    var copy = function (p) {
      blocks.forEach(function (el, i) {
        var a = +el.getAttribute('data-in') / 100, z = +el.getAttribute('data-out') / 100;
        var o = (i === 0 ? 1 : smooth(a, a + 0.045, p)) * (z >= 1 ? 1 : 1 - smooth(z, z + 0.04, p));
        el.style.opacity = o.toFixed(3);
        el.style.pointerEvents = o < 0.5 ? 'none' : '';
        el.style.transform = 'translate3d(0,' + ((1 - o) * (p < a + 0.045 ? 22 : -22)).toFixed(1) + 'px,0)';
      });
    };
    var draw = function (blend, force) {
      copy(current);
      if (!set) { applyTheme(current); return; }
      var p = current, pos = p * (set.count - 1), lo = Math.floor(pos);
      var m = blend && frames[lo] && frames[lo + 1] ? pos - lo : 0;
      var i = m > 0 ? lo : nearest(Math.round(pos));
      if (i < 0) { applyTheme(p); return; }
      var key = i + Math.round(m * 32) / 32;
      if (!force && key === drawn) return;
      drawn = key;
      paint(frames[i], m > 0 ? frames[lo + 1] : null, m, p);
    };
    var resize = function () {
      if (!set) return;
      var dpr = Math.min(devicePixelRatio || 1, 2, Math.max(1, set.width / Math.max(1, canvas.clientWidth)));
      canvas.width = Math.round(canvas.clientWidth * dpr); canvas.height = Math.round(canvas.clientHeight * dpr);
      drawn = -1; draw(false, true);
    };
    var loadImage = function (src, done) {
      var im = new Image(); im.src = src;
      im.decode().then(function () { done(im); }, function () { done(null); });
    };
    var wake = function () { drawn = -1; lastMove = performance.now(); kick(); };      // пришёл кадр: перерисовать, даже если прокрутка стоит
    var load = function () {
      if (!alive) return;
      var want = portraitOk && narrow.matches ? 'm' : 'd';
      if (want === loading) return;                    // этот набор уже на экране или грузится
      loading = want;
      var tset = want === 'm' ? manifest.portrait : manifest;
      var mine = ++generation, pending = new Array(tset.count).fill(null), order = [], seen = {}, next = 0, got = 0;
      var push = function (i) { if (i >= 0 && i < tset.count && !seen[i]) { seen[i] = 1; order.push(i); } };
      push(0); push(tset.count - 1);
      for (var step = 16; step >= 1; step >>= 1) for (var i = 0; i < tset.count; i += step) push(i);
      var live = function () { return alive && mine === generation; };
      var pump = function () {
        if (!live()) return;
        if (next >= order.length) {
          if (tset.loop && next === order.length) {
            next++;
            var lp = new Array(tset.loop.count).fill(null), left = tset.loop.count;
            lp.forEach(function (_, j) { loadImage(urlOf(want + 'loop', j), function (im) { lp[j] = im; if (--left === 0 && live() && set === tset) { loop = lp; wake(); } }); });
          }
          return;
        }
        var idx = order[next++];
        loadImage(urlOf(want, idx), function (im) {
          if (!live()) return;
          if (im) {
            pending[idx] = im; got++;
            if (frames !== pending) { set = tset; kind = want; frames = pending; loop = []; resize(); }
            wake();
          } else if (idx === 0 && !got) {
            // Первого кадра нет. Портретного набора в магазине может не быть: тогда работаем на широком.
            // Нет и широкого: секция становится статичной, как без JS.
            generation++; loading = '';
            if (want === 'm') { portraitOk = false; load(); } else if (!set) { alive = false; root.classList.add('eb-unfold--static'); }
            return;
          }
          pump();
        });
      };
      for (var k = 0; k < 6; k++) pump();
    };

    // один цикл: сглаживает долю прокрутки, рисует кадр, в конце крутит зацикленную воду
    var tick = function (now) {
      raf = 0;
      if (!visible || !alive) return;
      var prev = current;
      current += (target - current) * 0.14;
      if (Math.abs(target - current) < 0.0004) current = target;
      var moving = current !== prev;
      if (moving) lastMove = now;
      var ready = set && set.loop && loop.length && loop.every(Boolean);
      if (current > 0.996 && ready && !moving) {
        if (!loopStart) loopStart = now;
        var n = loop.length, pos = ((now - loopStart) / 1000 * (set.loop.fps || 24)) % n, lo = Math.floor(pos);
        copy(1); paint(loop[lo], loop[(lo + 1) % n], pos - lo, 1); drawn = -1;
      } else {
        loopStart = 0;
        draw(now - lastMove < 160, false);
      }
      if (moving || now - lastMove < 220 || (current > 0.996 && ready)) raf = requestAnimationFrame(tick);
    };
    var kick = function () { if (!raf && visible && alive) raf = requestAnimationFrame(tick); };
    var span = function () { return root.offsetHeight - stage.offsetHeight; };
    // В Horizon от 990 px страницу крутит .page-wrapper, а не окно: window.scrollY там всегда 0, событие scroll
    // на window не приходит (то же учтено в assets/eb.js). Долю считаем по положению секции на экране.
    var scroller = function () {
      var w = document.querySelector('.page-wrapper');
      return w && w.scrollHeight > w.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(w).overflowY) ? w : null;
    };
    var onScroll = function () {
      var s = span(), r = root.getBoundingClientRect(), vh = window.innerHeight;
      target = s > 0 ? Math.min(1, Math.max(0, -(r.top - (parseFloat(getComputedStyle(stage).top) || 0)) / s)) : 0;
      // кадры начинают грузиться, когда до секции остаётся около полутора экранов
      if (!started && r.top < vh * 2.5 && r.bottom > -vh) { started = true; load(); }
      kick();
    };
    // фокус с клавиатуры на ссылке блока докручивает страницу до его окна
    blocks.forEach(function (el) {
      el.addEventListener('focusin', function () {
        var a = +el.getAttribute('data-in') / 100, z = +el.getAttribute('data-out') / 100, p = Math.min(0.99, a + 0.05);
        if (current >= a + 0.04 && current <= z) return;
        var sc = scroller(), y = root.getBoundingClientRect().top + (sc ? sc.scrollTop : scrollY) - (parseFloat(getComputedStyle(stage).top) || 0) + p * span();
        if (sc) sc.scrollTop = y; else scrollTo(0, y);
      });
    });
    // мышь: наведение раскрывает карточку, клик по половине ведёт туда же, куда подпись
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      pointer = { x: e.clientX, y: e.clientY };
      hover();
    });
    stage.addEventListener('pointerleave', function () { pointer = null; hover(); });
    stage.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, mouse: e.pointerType === 'mouse' }; });
    // Клик по половине: только мышью (на телефоне ведёт сама подпись), только основной кнопкой, не после
    // протяжки и не при выделенном тексте. С Cmd, Ctrl или Shift открывает новую вкладку, как обычная ссылка.
    stage.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || !e.detail || !down || !down.mouse) return;
      if (e.target.closest && e.target.closest('a,button')) return;
      if (Math.abs(e.clientX - down.x) > 5 || Math.abs(e.clientY - down.y) > 5) return;
      if (String(getSelection ? getSelection() : '') !== '') return;
      var side = sideAt(e.clientX, e.clientY), l = side && labels[side];
      if (!l || l.tagName !== 'A') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) window.open(l.href, '_blank', 'noopener'); else location.href = l.href;
    });
    ['cool', 'warm'].forEach(function (name) {
      var l = labels[name]; if (!l) return;
      l.addEventListener('focus', hover);
      l.addEventListener('blur', function () { setTimeout(hover, 0); });
    });
    var ro = new ResizeObserver(function () { resize(); onScroll(); });
    var seen = new IntersectionObserver(function (e) { visible = e[e.length - 1].isIntersecting; if (visible) { onScroll(); kick(); } }, { rootMargin: '200px 0px' });
    var relayout = function () { if (started) load(); };
    // scroll не всплывает, но ловится на document в фазе перехвата: так слышно и окно, и .page-wrapper
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    ro.observe(stage); seen.observe(root);
    narrow.addEventListener('change', relayout);
    copy(0); applyTheme(0); onScroll();
    root.__ebUnfold = {
      stop: function () {
        alive = false; generation++; cancelAnimationFrame(raf);
        document.removeEventListener('scroll', onScroll, { capture: true }); ro.disconnect(); seen.disconnect(); narrow.removeEventListener('change', relayout);
      }
    };
  }

  function start(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-eb-unfold]'), function (root) { init(root, window.EBUnfoldManifest); });
  }
  if (window.__ebUnfoldBoot) { start(); return; }       // второй тег script на странице: только досмотреть новые секции
  window.__ebUnfoldBoot = true;
  start();
  // редактор темы перерисовывает секцию: старую останавливаем, новую запускаем
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-eb-unfold]'), function (root) { if (root.__ebUnfold) root.__ebUnfold.stop(); });
  });
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
